import { render, staticRenderFns } from "./organization-process-category-form.vue?vue&type=template&id=7e9c45b0&"
import script from "./organization-process-category-form.vue?vue&type=script&lang=js&"
export * from "./organization-process-category-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports